import React, { useState } from "react";
import Header from "../../../../components/molecules/Header";
import { useHistory } from "react-router-dom";
import { auth } from "../../../../components/firebase/FirebaseProvider";
import useStyles from "./style";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import ListSubheader from "@material-ui/core/ListSubheader";
import Divider from "@material-ui/core/Divider";
import CreateIcon from "@material-ui/icons/Create";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import ChromeReaderModeIcon from "@material-ui/icons/ChromeReaderMode";
import GroupIcon from "@material-ui/icons/Group";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import FingerprintIcon from "@material-ui/icons/Fingerprint";
import PhonelinkSetupIcon from "@material-ui/icons/PhonelinkSetup";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import {
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import { useData } from "../../../../components/firebase/DataProvider";
function Pengaturan() {
  const history = useHistory();
  const classes = useStyles();

  const { phone } = useData();

  const logout = () => {
    auth.signOut();
  };

  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      <Header
        type="with-title"
        title="Pengaturan"
        onClick={() => history.push("/akun")}
      />
      <div className={classes.wrapPengaturan}>
        <List
          className={classes.listPadding}
          subheader={
            <ListSubheader className={classes.list} disableSticky={true}>
              Akun
            </ListSubheader>
          }
        >
          <ListItem button onClick={() => history.push("/akun/ubahtoko")}>
            <ListItemIcon>
              <PhonelinkSetupIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Ubah Profil Toko" />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                size="small"
                onClick={() => history.push("/akun/ubahtoko")}
              >
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem button onClick={() => history.push("/akun/ubahseller")}>
            <ListItemIcon>
              <CreateIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Ubah Profil Seller" />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                size="small"
                onClick={() => history.push("/akun/ubahseller")}
              >
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem button onClick={() => history.push("/alamat")}>
            <ListItemIcon>
              <ChromeReaderModeIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Daftar Alamat Pembeli" />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                size="small"
                onClick={() => history.push("/alamat")}
              >
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem
            button
            onClick={() => history.push("/transaksi/jaringansaya")}
          >
            <ListItemIcon>
              <GroupIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Team Saya" />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                size="small"
                onClick={() => history.push("/transaksi/jaringansaya")}
              >
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem button onClick={() => history.push("/akun/verifikasi")}>
            <ListItemIcon>
              <VerifiedUserIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Verifikasi Ktp" />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                size="small"
                onClick={() => history.push("/akun/verifikasi")}
              >
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
        </List>
        <List
          className={classes.listPadding}
          subheader={
            <ListSubheader className={classes.list} disableSticky={true}>
              Keamanan
            </ListSubheader>
          }
        >
          <ListItem button onClick={() => history.push("/akun/ubahsandi")}>
            <ListItemIcon>
              <FingerprintIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Ubah Kata Sandi" />
            <ListItemSecondaryAction>
              <IconButton edge="end" size="small">
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          {/* <Divider /> */}
          <ListItem button onClick={() => setOpenDialog(true)}>
            <ListItemIcon>
              <CancelOutlinedIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Hapus Akun Anda" />
            <ListItemSecondaryAction>
              <IconButton edge="end" size="small">
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
        </List>
        <List>
          <ListItem button onClick={logout}>
            <ListItemIcon>
              <ExitToAppIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Keluar" />
            <ListItemSecondaryAction>
              <IconButton edge="end" size="small">
                <NavigateNextIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
        </List>
      </div>
      <Dialog
        open={openDialog}
        keepMounted
        onClose={() => setOpenDialog(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        className={classes.dialog}
      >
        <DialogContent>
          {/* <Grid container justify="center" alignItems="center">
            <Grid item>
              <ReportProblemOutlinedIcon fontSize="large" color="secondary" />
            </Grid>
          </Grid> */}
          <DialogTitle id="alert-dialog-slide-title">
            <Typography
              style={{ fontWeight: "bold", marginBottom: "10px" }}
              variant="h5"
            >
              Konfirmasi
            </Typography>
            <Typography className={classes.centerText}>
              Yakin ingin menghapus Akun Tokorame anda?
            </Typography>
          </DialogTitle>
        </DialogContent>
        <DialogActions>
          <ButtonGroup fullWidth variant="text">
            <Button onClick={() => setOpenDialog(false)}>Batalkan</Button>
            <Button
              onClick={() =>
                window.open(
                  `https://api.whatsapp.com/send/?phone=6281268000433&text=Hallo Admin Tokorame,
                  Saya ingin menghapus akun Tokorame saya, Nomor saya: ${phone?.id}&app_absent=0`
                )
              }
            >
              Yakin
            </Button>
          </ButtonGroup>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Pengaturan;
